import { FC, Dispatch, useEffect, useState } from "react";
import { UserInterface } from "../../../middleware/interfaces/user/user-interface";
import {
  BytesToReadableSize,
  FormatDateFE,
} from "../../../helper/general/methods";

interface userSubscriptionDialogProps {
  user: UserInterface;
  dispatch: Dispatch<any>;
}

const UserSubscriptionDialog: FC<userSubscriptionDialogProps> = ({
  user,
  dispatch,
}) => {
  const [cancel, setCancel] = useState(false);

  useEffect(() => {
    if (cancel) {
      const updatedUser = { ...user, subscription: null };
      dispatch({
        type: "UPDATE_USER",
        payload: updatedUser,
        response: "",
      });
      setCancel(false);
    }
  }, [cancel]);

  return (
    <>
      {(() => {
        if (user.subscription) {
          return (
            <div className="dialogCover">
              <div id="subscriptionDialog">
                <h2 className="dialogTitle">SUBSCRIPTION</h2>
                <div className="dialogValueWrapper">
                  <span className="dialogMessage">Subscription Plan:</span>
                  <input
                    type="text"
                    name="subscriptionPlan"
                    value={user.subscription.userSubscriptionPlan}
                    readOnly
                  />
                </div>
                <div className="dialogValueWrapper">
                  <span className="dialogMessage">Subscription Status:</span>
                  <input
                    type="text"
                    name="subscriptionStatus"
                    value={user.subscription.userSubscriptionStatus}
                    readOnly
                  />
                </div>
                <div className="dialogValueWrapper">
                  <span className="dialogMessage">Start Date:</span>
                  <input
                    type="text"
                    name="subscriptionStartDate"
                    value={FormatDateFE(
                      user.subscription.userSubscriptionStartDate,
                      true
                    )}
                    readOnly
                  />
                </div>
                <div className="dialogValueWrapper">
                  <span className="dialogMessage">End Date:</span>
                  <input
                    type="text"
                    name="subscriptionEndDate"
                    value={FormatDateFE(
                      user.subscription.userSubscriptionEndDate,
                      true
                    )}
                    readOnly
                  />
                </div>
                <div className="dialogValueWrapper">
                  <span className="dialogMessage">Total Report Size:</span>
                  <input
                    type="text"
                    name="totalReportSize"
                    value={BytesToReadableSize(
                      user.subscription.userSubscriptionTotalSpaceUsed[
                        "TotalReportSize"
                      ]
                    )}
                    readOnly
                  />
                </div>
                <div className="dialogValueWrapper">
                  <span className="dialogMessage">Total File Size:</span>
                  <input
                    type="text"
                    name="totalFileSize"
                    value={BytesToReadableSize(
                      user.subscription.userSubscriptionTotalSpaceUsed[
                        "TotalFileSize"
                      ]
                    )}
                    readOnly
                  />
                </div>
                <div className="dialogValueWrapper">
                  <span className="dialogMessage">Total Space Available:</span>
                  <input
                    type="text"
                    name="totalSpaceAvailable"
                    value={BytesToReadableSize(
                      user.subscription.userSubscriptionTotalSpaceAvailable
                    )}
                    readOnly
                  />
                </div>
                <div className="dialogButtonWrapper">
                  <input
                    type="button"
                    name="cancel"
                    value="Cancel"
                    onClick={() => setCancel(true)}
                  />
                  <input
                    type="button"
                    name="subscribe"
                    value="Subscribe"
                    onClick={() =>
                      window.open(
                        "https://apps.autodesk.com/NAVIS/en/Detail/Index?id=7615486252567671603&appLang=en&os=Win64",
                        "_blank"
                      )
                    }
                  />
                </div>
              </div>
            </div>
          );
        } else {
          return <></>;
        }
      })()}
    </>
  );
};

export default UserSubscriptionDialog;
